import type { FC } from 'react';
import { Table as AntTable } from 'antd';
import type { TableProps as AntTableProps } from 'antd';

export interface CounterTableProps<T = Record<string, unknown>> extends AntTableProps<T> {
  /**
   * Pixel-perfect table matching camera-detail-page.png History section
   */
  isMobile?: boolean;
}

/**
 * CounterTable - Counter Page Table Component
 * Configured for exact visual match with screenshot
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- isMobile kept in API for future responsive features
export const CounterTable: FC<CounterTableProps> = ({ isMobile: _isMobile = false, ...props }) => {
  return (
    <div style={{ containerType: 'normal' }}>
      <AntTable
        {...props}
        pagination={
          props.pagination
            ? {
                showSizeChanger: false,
                className: 'text-fs-text-secondary',
                ...props.pagination,
              }
            : false
        }
        className="fs-table compact-table"
      />
    </div>
  );
};
